<template>
    <div id="res_wrapper">
        <div class="res_container">
            <div class="left_content">
                <h3>{{ detail. groupName}}</h3>
                <div class="knowledge_video">
                    <section-flash v-if="isFlash && rscID"
                                   :rsc-id="rscID"
                                   :time-stamp="timeStamp"
                                   :order-num="orderNum"
                                   @nextPlay="nextPlay"
                                   @prevPlay="prevPlay"
                                   @finishPlay="finishPlay"/>
                    <section-video v-if="!isFlash && rscID"
                                   :rsc-id="rscID"
                                   :time-stamp="timeStamp"
                                   :order-num="orderNum"
                                   @vnextPlayer="vNextPlay"
                                   @vFinishPlay="vFinishPlay"
                    />
                    <div class="video_bottom">
                        <ul>
                            <li class="play">
                                <span>{{ detail.playNum ? detail.playNum : 0}}</span>
                            </li>
                            <li class="time">
                                <span>{{ detail. createTime}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="right_content">
                <div class="titleTop"><h3>知识单名称</h3></div>
                <div class="list_content">
                    <div class="all_play">
                        <i class="el-icon-caret-right"></i>
                        <span @click="playAllRsc">全部播放</span>
                    </div>
                    <div class="knowledge_point_list">
                        <ul>
                            <template v-for="(item, index) in groupList">
                                <li :class="item.orderNum === orderNum ? 'active' : ''" :key="index">
                                    <span class="list_number">{{ index + 1 }}</span>
                                    <p class="list_title" @click="playRsc(item,false)">{{ item.partName }}</p>
                                    <span class="list_time">{{ item.startTime }}-{{ item.endTime }}</span>
                                    <div class="list_icon">
                                        <i class="el-icon-sort-up" @click="onSortUp(index, item.partID)"></i> |
                                        <i class="el-icon-sort-down"
                                           @click="onSortDown(index, item.partID, groupList.length)"></i> |
                                        <i class="el-icon-delete" @click="onSortDelete(index, item.partID)"></i>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { knowledgeList, deleteKnowledgeList, sortKnowledgeList, getKnowledgeDetail } from '@/api/knowledge';
  import { $Cookies, isMobile, isIEBrowser, canUseVideo } from '@/utils';
  import SectionFlash from '@/components/VideoPlayer/section-flash';
  import SectionVideo from '@/components/VideoPlayer/section-video';
  import flashEvent from '@/mixins/flashEvent';
  import videoEvent from '@/mixins/videoEvent';

  export default {
    name: 'KnowledgeDetail',
    components: { SectionFlash, SectionVideo },
    mixins: [flashEvent, videoEvent],
    data () {
      return {
        groupList: [],
        groupID: '',
        detail: [],
        rscID: '',
        timeStamp: {
          startTime: '',
          endTime: ''
        },
        orderNum: 1,
        isFlash: false
      };
    },
    beforeCreate () {
      const groupID =  this.$route.query.groupID || null;
      if (isMobile()) {
        window.location.href = `//www.g12e.org/m/knowledges/detail.html?groupID=${ groupID }`;
      }
    },
    created () {
      this.groupID = this.$route.query.groupID;
      const isIE = isIEBrowser();
      const isFlash = canUseVideo();
      if (isIE) {
        this.isFlash = true;
      } else {
        if (isFlash) {
          this.isFlash = true;
        } else {
          this.isFlash = false;
        }
      }
    },
    async mounted () {
      await this.getKnowledgeList();
      await this.getKnowledgeDetail();
      await this.playAllRsc();
    },
    methods: {
      async getKnowledgeList () {
        const params = {
          groupID: this.groupID
        };
        await knowledgeList(params).then(data => {
          if (data.success) {
            this.groupList = data.result.list;
            const { endTime, startTime, rscID, orderNum } = this.groupList[ 0 ];
            this.rscID = rscID;
            this.orderNum = orderNum;
            this.timeStamp = {
              endTime: endTime,
              startTime: startTime
            };
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      async getKnowledgeDetail () {
        const uid = $Cookies.get('uid');
        const params = {
          groupID: this.groupID,// this.groupID,
          userNo: uid   //uid
        };
        getKnowledgeDetail(params).then(data => {
          if (data.success) {
            this.detail = data.result;
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      // 上调
      async onSortUp (index, partID) {
        if (index === 0) {
          this.$message.warning('已在第一位！');
          return false;
        }
        const params = {
          groupID: Number(this.groupID),
          partID,
          type: -1
        };
        await sortKnowledgeList(params).then(data => {
          if (data.success) {
            this.$message({
              type: 'success',
              message: data.result.result
            });
            this.getKnowledgeList();
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      async onSortDown (index, partID, listLength) {
        if (index === (listLength - 1)) {
          this.$message.warning('已在最后一位！');
          return false;
        }
        const params = {
          groupID: Number(this.groupID),
          partID,
          type: 1
        };
        await sortKnowledgeList(params).then(data => {
          if (data.success) {
            this.$message({
              type: 'success',
              message: data.result.result
            });
            this.getKnowledgeList();
          } else {
            this.$message({
              type: 'error',
              message: data.errorMsg
            });
          }
        });
      },
      onSortDelete (index, partID) {
        this.$confirm('此操作将永久删除该知识点, 是否继续?', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const params = {
            groupID: Number(this.groupID),
            partID,
          };
          deleteKnowledgeList(params).then(data => {
            if (data.success) {
              this.$message({
                type: 'success',
                message: data.result.result
              });
              this.getKnowledgeList();
            } else {
              this.$message({
                type: 'error',
                message: data.errorMsg
              });
            }
          });
        }).catch(() => {
          return false;
        });
      },
      playRsc (val) {
        const { startTime, endTime, rscID, orderNum } = val;
        this.orderNum = orderNum;
        this.rscID = rscID;
        this.timeStamp = {
          endTime: endTime,
          startTime: startTime
        };
      },
      playAllRsc () {
        const { endTime, startTime, rscID, orderNum } = this.groupList[ 0 ];
        this.rscID = rscID;
        this.orderNum = orderNum;
        this.timeStamp = {
          endTime: endTime,
          startTime: startTime
        };
      }
    }
  };
</script>
